export default "__VITE_ASSET__DqR$ED2V__"